<template>
  <form name="fio">
    <div class="formStepTitle"> Заполните контактную информацию <span>(шаг 1 из 3) </span> </div>
      <!-- <rangeTopLine></rangeTopLine>
    <range></range>
    <rangeBottomLine></rangeBottomLine>
    <p class="rangeScreenDesc">Сумма свыше <span>{{rangeMax | moneyFormat}}</span> <span class="rubl">a</span> доступна со второго займа </p> -->
    <div id="pasSmartId">
<!--      <imageInput v-on:imageData="imageData"></imageInput>-->
    </div>
    <div class="inputsCollection">
      <div class="inputs2"> <fmInput :refs="'PHONE'" ></fmInput> </div>
      <div class="inputs2"> <fmInput :refs="'EMAIL'" ></fmInput> </div>
    </div>
    <div class="inputsCollection">
      <div class="inputs2"> <fmInput :refs="'FIRST_NAME'" ></fmInput> </div>
      <div class="inputs2"> <fmInput :refs="'LAST_NAME'" ></fmInput> </div>
    </div>
	<div class="inputsCollection">
      <div class="inputs2"> <fmInput :refs="'SECOND_NAME'" ></fmInput> </div>
      <div class="inputs2"> <fmInput :refs="'BIRTHDAY'" ></fmInput> </div>
    </div>
    <div class="inputs1">
      <fmSelectDadata v-if="!mobileAdressForm" :refs="'RESIDENTIAL_ADDRESS'" ></fmSelectDadata>
      <mobileAdressForm v-else  :refs="'RESIDENTIAL_ADDRESS'"></mobileAdressForm>
    </div>
    <div> <fmRadio :refs="'GENDER'"></fmRadio> </div>
    <nxtButton v-on:submitStep="submitStep"></nxtButton>
  </form>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  export default {
    name: "fio",
    data() {
      return {
        foto:'',
        refsStepArr:[
          'CALC_SUMM',
          'PHONE',
          'EMAIL',
          'RESIDENTIAL_ADDRESS',
          'SECOND_NAME',
          'LAST_NAME',
          'BIRTHDAY',
          'FIRST_NAME',
          'GENDER'
        ],
        smartIdKeyAlias: {
          authority: 'PASSPORT_DEP',
          authority_code: 'PASSPORT_DEP_CODE',
          birthdate: 'BIRTHDAY',
          birthplace: 'BIRTHPLACE',
          gender: 'GENDER',
          issue_date: 'PASSPORT_DATE',
          name: 'FIRST_NAME',
          number: 'PASSPORT_NUMBER',
          number_page2: 'PASSPORT_NUMBER',
          number_page3: 'PASSPORT_NUMBER',
          patronymic: 'SECOND_NAME',
          series: 'PASSPORT_SERIES',
          series_page2: 'PASSPORT_SERIES',
          surname: 'LAST_NAME',
        },
      }

    },
    components: {
      fmInput: () => import('@/components/form/fmInput'),
      nxtButton: () => import('@/components/form/nextButton'),
      fmSelectDadata: () => import('@/components/form/fmSelectDadata'),
      fmRadio:()=>import('@/components/form/fmRadio'),
      mobileAdressForm:()=>import('@/components/form/vmSelectDadataMobileWrap'),
      // imageInput:()=>import('@/components/form/imageInput'),
      // range: () => import('@/components/chunk/range'),
      // rangeTopLine: () => import('@/components/chunk/rangeTopLine'),
      // rangeBottomLine: () => import('@/components/chunk/rangeBottomLine'),
    },
    methods: {
      adressCheck: function(){
        let result = 0;
        return new Promise((resolve, reject) => {
          this.$palantir.trackAction(122,'');
          this.$myApi.SendRequest({
            action: 'GetAddressTerritory',
            Address: this.valueVuex.RESIDENTIAL_ADDRESS
          })
          // eslint-disable-next-line no-unused-vars
          .then((res)=>{
            if (window.ym) {
              // eslint-disable-next-line no-undef
              ym(51632228, 'reachGoal', ' admdAdressTrue');
            }
            if (window.ga){
              // eslint-disable-next-line no-undef
              ga('send', 'event', 'admdAdress', 'admdAdressTrue');
            }
            result = 1;
            this.$palantir.trackAction(123,'');
            resolve();
            // eslint-disable-next-line no-unused-vars
          })
          .catch((res) => {
            this.$palantir.trackAction(124,JSON.stringify(res));
            let ErrorResult = this.$myApi.parseError(res, 'fio adressCheck');
            if (ErrorResult.ExecutionErrorCode > 0) {
              this.$store.commit('saveScrMsg', 'К сожалению, на данный момент ваш населённый пункт не обслуживается, но наша компания быстро расширяется, возможно, скоро появимся и у вас,  ожидайте появления наружной рекламы');
              if (window.ym) {
                // eslint-disable-next-line no-undef
                ym(51632228, 'reachGoal', 'admdAdressFalse');
              }
              if (window.ga) {
                // eslint-disable-next-line no-undef
                ga('send', 'event', 'admdAdress', 'admdAdressFalse');
              }
              result = -1;
              try {
                switch (res.Response.ExecutionError.ExecutionErrorCode) {
                  case 1:
                    result = -1;
                    break;
                  case 2:
                    result = -2;
                    break;
                  default:
                    result = -1;
                    break;
                }
              } catch (e) { result = -1; }
              reject();
            } else {
              //случилась некая херня неожиданная, продолжаем принимать заявку
              result = 0;
              this.$palantir.trackAction(125,'');
              resolve();
            }
          })
          .finally(() => {
            this.$myApi.singleRequest({action:'adressZoneLog', value: result});
          });
        });
      },
      submitStep() {
        this.$store.dispatch('showLoading');
        this.$palantir.trackAction(115,'');
        if (this.checkFormFieldValue()){
          this.$myApi.singleRequest({
            action:'AddShortRequest',
            data:{
              'PHONE':this.valueVuex['PHONE'],
              'FIRST_NAME':this.valueVuex['FIRST_NAME'],
              'LAST_NAME':this.valueVuex['LAST_NAME'],
              'BIRTHDAY':this.valueVuex['BIRTHDAY'],
              'SECOND_NAME':this.valueVuex['SECOND_NAME'],
              'RESIDENTIAL_ADDRESS':this.valueVuex['RESIDENTIAL_ADDRESS'],
              'RESIDENTIAL_ADDRESS_DADATA':this.valueVuex['RESIDENTIAL_ADDRESS_DADATA'],
            },
          });
          this.isIssetActiveRequest()
          .then(this.adressCheck)
            .then(()=>{ this.$store.dispatch('formRouting','passport'); } ).catch(()=>{
              //что то пошло не так в проверках
              if (this.doesNotRedirect) {
                if (this.doesNotRejectRequest) {
                  this.$palantir.trackAction(126,JSON.stringify({
                    doesNotRedirect: this.doesNotRedirect,
                    doesNotRejectRequest: this.doesNotRejectRequest
                  }));
                  this.$store.dispatch('formRouting','passport');
                } else {
                  this.$palantir.trackAction(127,JSON.stringify({
                    doesNotRedirect: this.doesNotRedirect,
                    doesNotRejectRequest: this.doesNotRejectRequest
                  }));
                  this.$store.dispatch('formRouting','scrEndError');
                }
              } else {
                this.$palantir.trackAction(128,window.linkToMarket);
                document.location.href = window.linkToMarket;
              }
              this.$store.dispatch('hideLoading');
              window.dblClick = false;
            });
        } else {
          //не заполнены поля
          this.$store.dispatch('hideLoading');
          window.dblClick = false;
        }
      },
      checkFormFieldValue(){
        //проверяем заполнения полей
        let checkAdress = this.isAdressValid('RESIDENTIAL_ADDRESS');
        let isFormFieldCorrect = true;
        if (checkAdress.length > 0) {
          this.$store.dispatch('fieldError', {
            target: 'RESIDENTIAL_ADDRESS',
            value: checkAdress
          });
          this.$palantir.trackAction(116,'RESIDENTIAL_ADDRESS');
          isFormFieldCorrect =  false;
        }
        this.refsStepArr.forEach(item => {
          if (this.statusVuex[item].code != 0) {
            this.$palantir.trackAction(117,item);
            this.$store.dispatch('errorShow', {
              target: item,
              value: true,
            });
            isFormFieldCorrect = false;
          }
        });
        return isFormFieldCorrect;
      },
      isIssetActiveRequest(){
        return new Promise((resolve, reject) => {
          this.$palantir.trackAction(118,'');
          this.$myApi.SendRequest({
            action: 'isIssetActiveRequest',
            data: {
              FIRST_NAME: this.valueVuex.FIRST_NAME,
              LAST_NAME: this.valueVuex.LAST_NAME,
              SECOND_NAME: this.valueVuex.SECOND_NAME,
              PHONE: this.valueVuex.PHONE
            },
            // eslint-disable-next-line no-unused-vars
          }).then(res=>{
            this.$palantir.trackAction(119,'');
            this.$myApi.singleRequest({ action: 'checkfioLog', value: 0 });
            resolve();
          }).catch(res=>{
            this.$palantir.trackAction(120,JSON.stringify(res));
            let ErrorResult = this.$myApi.parseError(res, 'fio isIssetActiveRequest');
            if (ErrorResult.ExecutionErrorCode > 0) {
              this.$store.commit('saveScrMsg', 'К сожалению компания отказала вам в выдаче займа, повторное обращение возможно через 1 месяц.');
              if (window.ym) {
                // eslint-disable-next-line no-undef
                ym(51632228, 'reachGoal', 'admdScoringFail');
              }
              this.$myApi.singleRequest({
                action: 'checkfioLog',
                value: ErrorResult.ExecutionErrorMessage
              });
              reject();
            } else {
              this.$palantir.trackAction(121,JSON.stringify(res));
              //случилась некая херня неожиданная, продолжаем принимать заявку
              resolve();
            }
          });
        });
      },
      imageData(value){
        this.foto = value.value;
        this.fotoSmartId();
      },
      fotoSmartId(){
        this.$store.dispatch('showLoading');
        this.$palantir.trackAction(146,'');
        this.$myApi.singleRequest({ action:'fotoPass', fotoPas:this.foto, }).then(res=>{
          this.$palantir.trackAction(147, JSON.stringify(res));
          for (let item in this.smartIdKeyAlias) {
            if(res['SmartID'][item] !=  undefined){
              if (item == 'birthdate' || item == 'issue_date'){ let tmp = res['SmartID'][item]; res['SmartID'][item] = tmp.replace(/(\d{2}).(\d{2}).(\d{4})/,'$3-$2-$1') }
              this.$store.dispatch('saveSendData', { target: this.smartIdKeyAlias[item], value: res['SmartID'][item] });
            }
          }
          this.$store.dispatch('saveSendData', { target:'smartIdFileID', value: res } );
          this.$store.dispatch('hideLoading');
        }).catch(res=>{
          this.$palantir.trackAction(148,JSON.stringify(res));
          let ErrorResult = this.$myApi.parseError(res, 'fio smartID');
          if (ErrorResult.ExecutionErrorCode > 0) { alert(ErrorResult.ExecutionErrorMessage); }
          this.$store.dispatch('hideLoading');
        });
      }
    },
    mounted() {
      this.$store.dispatch('hideLoading');
      window.dblClick = false;



      // window.scrollTo({
      //   left:0,
      //   top:this.$parent.$refs.formAlign.offsetTop,
      //   behavior: 'smooth'
      // });

      // if (window.ga){
      //   // eslint-disable-next-line no-undef
      //   ga('send', 'event', 'admdForm', 'admdPhoneCheck');
      // }
      // if (window.ym) {
      //   // eslint-disable-next-line no-undef
      //   ym(51632228, 'reachGoal', 'admdPhoneCheck');
      //   // eslint-disable-next-line no-undef
      //   ym(51632228, 'reachGoal', 'admdChainPhone');
      // }


    },

    computed: {
      ...mapGetters([ 'isAdressValid', 'getRedirectUrl', 'doesNotRedirect', 'doesNotRejectRequest', ]),
      ...mapState({
        rangeMax: state => state.Deal.MaxSumm,
        statusVuex: state => state.Form.workData,
        valueVuex: state => state.Form.sendData,
        mobileAdressForm: state => state.Form.system.isMobileAdressForm
      }),
    }
  }
</script>

<style scoped>
  /deep/ .fmRange .fmRangeBar {background: #97B0A9;}
  .rangeScreenDesc {font-size: 4.4vw;text-align: center;padding: 3.2vw 0 4.7vw;}
  .rangeScreenDesc span {font-weight: bold;}
  .formStepTitle{font-size: 4.9vw;font-weight: bold;padding: 3.7vw 0; text-align: center;}
  @media screen and (min-width: 760px) {
    .rangeScreenDesc {font-size: 1.3vw;text-align: left;padding: 0.9vw 0 1.4vw;}
    .formStepTitle {font-size: 2.7vw;}
  }
  @media screen and (min-width: 1140px) {
    .rangeScreenDesc { padding: 10px 0 15px;font-size: 14px;}
    form {width: calc(100% - 128px);}
    .inputs2 {width: 49%;}
    .formStepTitle {font-size: 1.5vw;}
  }
</style>
